<template>
    <div class="new-pass-page">
        <div class="center-area">
            <a class="app-logo"><img src="@/assets/img/funnelish-logo.svg"></a>

            <h4 class="">
                Enter your new password below
            </h4>

            <div class="form-group" >
	            <input-field :icon="require('@/assets/img/input-email-icon.svg')" type="email"
	                          v-model="email" readonly style="display: none" />

	            <input-field :icon="require('@/assets/img/input-password-icon.svg')" type="password"
	                         placeholder="Your new password" v-model="password" />
              <input-field class="margin-t-25" :icon="require('@/assets/img/input-password-icon.svg')" type="password"
                           placeholder="Repeat your password" v-model="password2" />

            </div>
            <div>
              <span v-if="isWeak" style="color: red;">Set a stronger password!</span>
            </div>

            <v-button class="login-btn" :loading="loading" :disabled="password!==password2 || !password"
                      @click="newPass" label="Change my password"></v-button>

	          <router-link to="/log-in" class="form-link">Return to Log In</router-link>

	        <div class="tos">
		        © 2023 Funnelish. All rights reserved.
		        <a href="https://funnelish.com/privacy" target="_blank">Privacy</a> and
		        <a href="https://funnelish.com/tos" target="_blank">terms</a>.
	        </div>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import VButton from "@/components/base/v-button";
import API from '@/api';
import InputField from "@/components/base/input-field";

export default {
	name: "NewPassword",
	title:"New Password | Funnelish™",
	mixins: [API],
	components: {InputField, VButton },
	data: function () {
		return {
			password2: '',
			password: '',
			loading: false,
			vcode: '',
			email: '',
		}
	},
	computed:{
		isWeak: function () {
			if (this.password !== this.password2 || !this.password) return false; // don't validate yet!
			return this.password.length < 5;
		}
	},
	methods: {

		async newPass() {
			try {
				this.loading = true;
				if (this.password!==this.password2) {
					this.$notify({
						group: 'main',
						title: "Password don't match.",
						type: 'error',
					});
					return
				}
				let r = await this.api.users.newPassword(this.email, this.vcode, this.password);
				if (r.error) {
					this.$notify({
						group: 'main',
						title: r.info.data,
						type: 'error',
					});
					console.error("error", r.info);
				} else {
					this.$notify({
						group: 'main',
						title: "Your password changed successfully!",
						type: 'info',
					});
					this.$router.push({path:'log-in', query:{pass_updated:'true'}});
				}
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		}
	},

	created() {
		this.vcode = this.$route.query.vcode;
		this.email = this.$route.query.email;
	}
}
</script>
<style lang="scss" scoped>
.new-pass-page {
	background: url(/img/bg-main.jpeg) bottom center;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 50px 10px;
	background-size: cover;

	.login-link {
		position: absolute;
		top: 20px;
		right: 25px;
		font-size: 14px;
		color: grey;
		font-weight: 400;
		&:hover {
			text-decoration: underline;
		}
	}
	.app-logo {
		margin: 15px auto;
	}
	@media only screen and (max-width: 400px){
		.center-area {
			padding: 20px 5px !important;
		}
	}
	.center-area {
		position: relative;
		background: white;
		border-radius: 10px;
		box-shadow: 0 8px 20px 0 rgb(0 0 0 / 6%);
		display: flex;
		margin: auto;
		max-width: 500px;
		min-width: 400px;
		padding: 20px 30px;
		flex-direction: column;
	}
	.error {
		color: red;
	}
	.tos {
		margin-top: 20px;
		color: #919299;
		a {
			color: #919299 !important;
		}
	}
	a:not(.button) {
		font-size: 14px;
		color: $blue;
		&:hover {
			text-decoration: underline;
		}
	}
	.forgot-pass {
		font-size: 14px;
		color: $blue;
		margin: 15px;
		text-align: center;
	}
	.no-account {
		font-size: 14px;
		color: $black;
		margin: 15px;
		text-align: center;
	}
	h4 {
		color: $dark-grey;
		text-align: center;
		font-weight: 300;
		font-size: 16px;
		margin: 15px 0;
		line-height: 1.5;
	}
}

</style>

<style lang="scss">
.new-pass-page {
	.login-btn {
		background: $sharp-blue;
		margin: 20px auto;
		width: 100%;
		display: flex;
		.label {
			margin: auto;
		}
	}
	.input-field {
		height: 48px;
		margin-top: 15px;
		input {
			border-radius: 6px;
		}
		.icon {
			padding: 3px 8px 3px 8px;
		}
	}
}
</style>
